import { Stack } from '@mui/material';
import HomeGreeter from '../components/HomeGreeter';
import HomeRachelInput from '../components/HomeRachelInput';

const BrandHome = () => (
  <Stack
    spacing={3}
    useFlexGap
    sx={{ minHeight: '100%', alignItems: 'center', justifyContent: 'center' }}
  >
    <HomeGreeter />
    <HomeRachelInput />
  </Stack>
);

export default BrandHome;
